'use strict';

import React, { PropTypes } from 'react';
import TabLink from './TabLink';
import RouterStateMixin from '../mixins/RouterStateMixin';
import PureRenderMixin from '../mixins/PureRenderMixin';

const TabRouterLink = React.createClass({
  mixins: [RouterStateMixin, PureRenderMixin],

  propTypes: {
    onClick: PropTypes.func,
    to: PropTypes.string,
    params: PropTypes.object
  },

  contextTypes: {
    router: PropTypes.func
  },

  render() {
    const { router: { isActive }} = this.context;

    return (
      <TabLink to={this.props.to}
               onClick={this.props.onClick}
               params={this.props.params}
               active={isActive(this.props.to)}>
        {this.props.children}
      </TabLink>
    );
  }
});

export default TabRouterLink;



/** WEBPACK FOOTER **
 ** ./atoms/TabRouterLink.jsx
 **/